import React from 'react';
import styled from 'styled-components';
import { Checkbox } from 'antd';
import { theme } from 'utils/style/theme';

/**
 *
 * @returns {기본 체크박스 - 단일}
 */

interface IProps {
  onChange?: (e) => void;
  disabled?: boolean;
  defaultChecked?: boolean;
  checked?: boolean;
  children?: string;
  name?: string;
  className?: string;
  large?: boolean;
  style?: React.CSSProperties;
  border?: boolean; //Maintable, SubordinateTable에서 disabled가 아닌경우에 처리함
  id?: string;
}
const CheckboxOneType: React.FC<IProps> = ({
  onChange,
  defaultChecked,
  checked,
  disabled,
  children,
  name,
  className,
  large,
  style,
  border,
  id,
}) => {
  return (
    <StyledCheckbox
      className={large ? 'large' : className} //클래스네임으로 관리
      name={name}
      defaultChecked={defaultChecked}
      checked={checked}
      onChange={onChange}
      disabled={disabled}
      style={style}
      border={border}
      id={id}
    >
      {children}
    </StyledCheckbox>
  );
};

export default CheckboxOneType;
const StyledCheckbox = styled(Checkbox)<IProps>`
  /* background-color: blue; */
  .ant-checkbox-inner {
    border: 1px solid ${theme.colors.gray_3};
  }
  .ant-checkbox-checked .ant-checkbox-inner {
    /* border: solid 2px blue; */
    background-color: ${theme.colors.blue_2};
    border-color: ${theme.colors.blue_2};
  }
  .ant-checkbox-inner {
    height: 1.3rem;
    width: 1.3rem;
    border: ${(props) =>
      props.border ? `solid 1px ${theme.colors.blue_2}` : ''};
  }

  .ant-checkbox-disabled .ant-checkbox-inner {
    background-color: #f5f5f5;
  }
  &.check_vertical {
    margin-right: 1rem;
  }
  &.large {
    .ant-checkbox-inner {
      /* border: solid 2px blue; */
      height: 3rem;
      width: 3rem;
      /* background: red; */
      &::after {
        transform: translate(50%, -50%) rotate(45deg) scale(2);
        margin-left: 0.4rem;
        margin-bottom: 0.5rem;
        /* width: 1em; */
      }
    }
  }
`;
